import { backendApi } from "../dynamicBAseQuery";

export const UserChatApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        chatRecentList: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: "chatRecentList",
                body: { ...args }
            })
        }),
        chatNameList: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: "chatNameList",
                body: { ...args }
            })
        }),
        history: builder.mutation({
            query: (args) => ({
                method: 'GET',
                url: "history",
                params: args
            })
        }),

        userChatNameList: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: "chatNameList",
                body: {...args}
            })
        }),

    })
})

export const {
    useChatRecentListMutation,
    useHistoryMutation,
    useUserChatNameListMutation,
} = UserChatApi
